export default {
  subtotal: 'Sous-total',
  tip: 'Pourboire',
  discount: 'Réduction',
  method_fee: 'Frais de livraison',
  service_fee: {
    title: 'Frais de service',
    description:
      "Ces petits frais de service nous aident à couvrir les coûts liés à chaque commande — comme l'envoi de SMS sur votre commande, le fonctionnement de notre plateforme de commande en ligne et les frais de transaction supplémentaires. Et rassurez-vous — ces frais restent bien inférieurs à ce que vous paieriez sur les applis de livraison. Merci pour votre compréhension et votre soutien direct. Nous vous en sommes reconnaissants !",
  },
  payment_method_upcharge_fee: {
    title: 'Frais PayPal',
    description:
      "Chaque fois qu'un client paie avec PayPal, PayPal prélève 6-7 % de frais. Sur 100 €, nous perdons donc 6-7 €. C'est pourquoi nous devons malheureusement ajouter un supplément de 3,5 % pour l'utilisation de PayPal. 🤯 Veuillez envisager d'utiliser l'un des autres moyens de paiement sécurisés et chiffrés. Nous vous sommes très reconnaissants de votre compréhension et de votre soutien ! 🙏",
  },
  tax: 'Taxes',
  total: 'Total',
  earned_points: 'Vous avez gagné {{points}} points',
};
